import { cn } from "../ClassName";

interface Props {
  fullscreen?: boolean;
  white?: boolean /** Used for white circles instead of accent blue */;
  size?: number;
  className?: string;
}

export const Loading: React.FC<Props> = ({
  fullscreen = false,
  white = false,
  size = 24,
  className,
}) => {
  return (
    <div
      className={cn("loading", fullscreen && "loading-fullscreen", className)}
    >
      <div className="tw-mx-auto tw-w-full tw-animate-spin">
        {white ? (
          <img
            className="tw-mx-auto tw-flex tw-items-center tw-justify-center"
            width={size}
            height={size}
            src="/icons/loading-indicator-white.png"
          />
        ) : (
          <img
            className="tw-mx-auto tw-flex tw-items-center tw-justify-center"
            width={size}
            height={size}
            src="/icons/loading-indicator-blue.png"
          />
        )}
      </div>
    </div>
  );
};
